export default __webpack_public_path__ + "static/media/nz.e7bae5b7.svg";